import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MessageBubbleIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 1c6.58 0 12 4.189 12 9.5 0 3.326-2.154 6.39-5.427 8.132-1.665.886-3.522 1.368-5.35 1.368h-4.89c-.03 0-.059-.001-.088-.004l-5.798 2.898a1 1 0 01-1.417-1.137l1.317-5.273A8.843 8.843 0 010 10.5C0 5.189 5.42 1 12 1zm0 2C6.429 3 2 6.422 2 10.5c0 1.654.626 3.304 1.724 4.527l.019.003a1 1 0 01.727 1.213l-.973 3.89 4.056-2.027a.995.995 0 01.613-.092l.05-.007.117-.007h4.89c1.494 0 3.03-.399 4.41-1.134C20.297 15.45 22 13.026 22 10.5 22 6.422 17.571 3 12 3z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
MessageBubbleIcon.isCarinaIcon = true;
export default MessageBubbleIcon;
